import { createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import navigationConfig from 'app/fuse-configs/navigationConfig';
import FuseUtils from '@fuse/utils';
import i18next from 'i18next';
import _ from 'lodash';

const navigationAdapter = createEntityAdapter();
const emptyInitialState = navigationAdapter.getInitialState();
const initialState = navigationAdapter.upsertMany(emptyInitialState, navigationConfig);

export const appendNavigationItem = (item, parentId) => (dispatch, getState) => {
	const navigation = selectNavigationAll(getState());
	return dispatch(setNavigation(FuseUtils.appendNavItem(navigation, item, parentId)));
};

export const prependNavigationItem = (item, parentId) => (dispatch, getState) => {
	const navigation = selectNavigationAll(getState());
	return dispatch(setNavigation(FuseUtils.prependNavItem(navigation, item, parentId)));
};

export const updateNavigationItem = (id, item) => (dispatch, getState) => {
	const navigation = selectNavigationAll(getState());
	return dispatch(setNavigation(FuseUtils.updateNavItem(navigation, id, item)));
};

export const removeNavigationItem = id => (dispatch, getState) => {
	const navigation = selectNavigationAll(getState());
	return dispatch(setNavigation(FuseUtils.removeNavItem(navigation, id)));
};

export const {
	selectAll: selectNavigationAll,
	selectIds: selectNavigationIds,
	selectById: selectNavigationItemById
} = navigationAdapter.getSelectors(state => state.fuse.navigation);

const navigationSlice = createSlice({
	name: 'navigation',
	initialState,
	reducers: {
		setNavigation: navigationAdapter.setAll,
		resetNavigation: () => initialState
	}
});

export const { setNavigation, resetNavigation } = navigationSlice.actions;

const getUserRole = state => {
	const role = state?.auth?.user?.role;
	if (process.env.NODE_ENV !== 'production') {
		// eslint-disable-next-line no-console
		console.log('[navigation] userRole:', role);
	}
	return role;
};

export const selectNavigation = createSelector(
	[selectNavigationAll, ({ i18n }) => i18n.language, getUserRole],
	(navigation, language, userRole) => {
		const filtered = FuseUtils.filterRecursive(navigation, item =>
			FuseUtils.hasPermission(item.auth, userRole)
		);

		const deep = _.cloneDeep(filtered);

		const setTranslationValues = data =>
			data.map(it => {
				const item = { ...it };
				if (item.translate && item.title) {
					item.title = i18next.t(`navigation:${item.translate}`);
				}
				if (item.children) {
					item.children = setTranslationValues(item.children);
				}
				return item;
			});

		return setTranslationValues(deep);
	}
);

export const selectFlatNavigation = createSelector(
	[selectNavigation],
	navigation => FuseUtils.getFlatNavigation(navigation)
);

export default navigationSlice.reducer;
